import { MdxPage } from '@features/mdx/MdxPage';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: '93d79456-bc28-4460-8d07-a58cb299175e',
	[LanguageEnum.SK]: '93d79456-bc28-4460-8d07-a58cb299175e',
	default: '93d79456-bc28-4460-8d07-a58cb299175e'
}


export const History = () => {

	return (
		<MdxPage className='history-page' articleIds={articleIds}>
		</MdxPage>
	);
};